import { Fragment, Suspense } from "react";
import ArrowUp from "../../assets/svg/ArrowUp";
import DropDownIcon from "../../assets/svg/DropdownIcon";

function CustomAccordion({
  index,
  activeIndex,
  handleQuestionClick,
  question: q,
  children,
  title,
  allExpanded
}: {
  index?: number;
  activeIndex?: number;
  handleQuestionClick?: Function;
  title?: string;
  question?: {
    title: string;
    description: string;
  };
  children?: React.ReactNode;
  allExpanded?: boolean
}) {
  return (
    <div key={index} className="mt-2 mb-2">
      <div
        className={`${!!title ? "" : "border"} rounded-md ${activeIndex === index && !!title === false
          ? "border-[#18B5B7]"
          : "shadow-sm"
          }`}
      >
        <button
          type="button"
          className={`w-full flex text-left justify-between font-medium text-royalBlue px-4 py-2 rounded focus:outline-none ${children ? "bg-sideMenuHoverBg hover:bg-dropDownBorder uppercase text-sm" : ""
            }`}
          onClick={() => {
            if (allExpanded) return
            handleQuestionClick?.(index)
          }}
        >
          {title ? title : q?.title ? q.title : ""}
          {!allExpanded && <span className="py-2">
            {(activeIndex === index) ? <ArrowUp /> : <DropDownIcon />}
          </span>}
        </button>
        <div
          className={`${children ? "" : "px-4"} text-royalBlue text-left ${(activeIndex === index) || allExpanded
            ? "py-4 h-auto opacity-100 transition-all duration-200 ease-in-out"
            : "py-0 h-0 opacity-0 transition-all duration-200 ease-in-out"
            }`}
        >
          {((activeIndex === index) || allExpanded) && (
            <Suspense fallback={<p>Loading...</p>}>
              {children ? (
                children
              ) : (
                <div
                  dangerouslySetInnerHTML={{ __html: q?.description ?? "" }}
                />
              )}
            </Suspense>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomAccordion;
